import { useTranslation } from 'react-i18next'
import React from 'react'
import { Link } from '../../types/Link'
import EmailsOverview from '../../compositions/EmailsOverview'

type EmailsProps = {
    link: Link
}

const Emails: React.FC<EmailsProps> = ({ link }) => {
    const { t } = useTranslation(['nav'])

    return (
        <div>
            <EmailsOverview />
        </div>
    )
}

export default Emails
